@if (isLoadingLabelVisible) {
  <div id="loaderModal" class="modal">
    <div class="modal-content">
      <p>Please wait, while table is loaded.</p>
    </div>
  </div>
}
<div class="container my-3 position-relative">
  @if (isReadOnly == false) {
    <button (click)="addContent()" type="button" class="btn btn-outline-secondary btn-sm noborder" data-bs-toggle="tooltip" data-bs-placement="top" title="Link content to this content" data-bs-delay="{show: 1000}" >
      <i class="bi bi-file-earmark-plus"></i>
    </button>
  }
  <div class="row w-100">
    @for (c of content; track c; let i = $index) {
      <div class="col-6 col-sm-12 col-md-6 col-lg-4 col-xl-2 my-1">
        <div class="card">
          <a (click)="launchPostDialog(c.key, '', '', false)" class="pointer" >
            @if (c.coverImageURL) {
              <img src="{{c.coverImageURL}}" class="card-img-top">
            }
            <div class="card-body">
            <!--h5 class="card-title">{{doc.name.slice(0, 30)}}</h5-->
            <p class="card-text">
              {{c.name.slice(0, 100)}}
            </p>
            @if (isReadOnly == false) {
              <button (click)="deleteContentLink(i)" type="button" class="btn btn-outline-secondary btn-sm noborder corner-position" data-bs-toggle="tooltip" data-bs-placement="top" title="Remove link to this content" data-bs-delay="{show: 1000}" >
                <i class="bi bi-file-earmark-minus"></i>
              </button>
            }
          </div>
        </a>
      </div>
    </div>
  }
</div>
</div>

<!-- popup window for searching content -->
<div class="position-fixed overflowmenu">
  @if (showSearchwModal && isReadOnly == false) {
    <app-postsearchpopup [organizationKey]="organizationKey" [projectKey]="projectKey" [userId]="userId" (foundContent)="receivedContent($event)"></app-postsearchpopup>
  }
</div>